// extracted by mini-css-extract-plugin
export var copied = "SocialButton-module--copied--d4a4d";
export var fa = "SocialButton-module--fa--229fc";
export var shareLink = "SocialButton-module--share-link--f53eb";
export var socialButton = "SocialButton-module--social-button--c2e49";